import React, { useEffect, useRef } from "react";
import { useVeltClient } from "../context";
/**
 * @beta This hook is in beta
 */
export function useLiveStateSyncUtils() {
    var _a = React.useState(), liveStateSyncElement = _a[0], setLiveStateSyncElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || liveStateSyncElement)
            return;
        var loadedLiveStateSyncElement = client.getLiveStateSyncElement();
        setLiveStateSyncElement(loadedLiveStateSyncElement);
    }, [client, setLiveStateSyncElement, liveStateSyncElement]);
    return liveStateSyncElement;
}
/**
 * @beta This hook is in beta
 */
export function useLiveStateData(liveStateDataId) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData))
            return;
        var subscription = liveStateSyncElement.getLiveStateData(liveStateDataId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData]);
    return data;
}
/**
 * @beta This hook is in beta
 */
export function useSetLiveStateData(liveStateDataId, liveStateData) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    React.useEffect(function () {
        if (liveStateSyncElement && liveStateDataId && liveStateData) {
            liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData(liveStateDataId, liveStateData);
        }
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData]);
}
/**
 * @beta This hook is in beta
 */
export function useUserEditorState() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isUserEditor))
            return;
        var subscription = liveStateSyncElement.isUserEditor().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isUserEditor]);
    return data;
}
/**
 * @beta This hook is in beta
 */
export function useEditor() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditor))
            return;
        var subscription = liveStateSyncElement.getEditor().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditor]);
    return data;
}
/**
 * @beta This hook is in beta
 */
export function useEditorAccessRequestHandler() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isEditorAccessRequested))
            return;
        var subscription = liveStateSyncElement.isEditorAccessRequested().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isEditorAccessRequested]);
    return data;
}
/**
 * @beta This hook is in beta
 */
export function useLiveState(liveStateDataId, initialValue, debounceTime) {
    if (debounceTime === void 0) { debounceTime = 50; }
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(initialValue), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData))
            return;
        var subscription = liveStateSyncElement.getLiveStateData(liveStateDataId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData]);
    var useDebounce = function (callback) {
        var callbackRef = useRef(callback);
        var timerRef = useRef(null);
        useEffect(function () {
            callbackRef.current = callback;
        });
        var debounce = function (value, delay) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(function () {
                callbackRef.current(value);
            }, delay);
        };
        return debounce;
    };
    var setDataFunction = function (value) {
        setData(value);
        debouncedOnInput(value, debounceTime); // default 50ms debounce time
    };
    var debouncedOnInput = useDebounce(function (value) {
        if (liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData) {
            liveStateSyncElement.setLiveStateData(liveStateDataId, value);
        }
    });
    return [data, setDataFunction];
}
